export const v3SidebarLinks = [
  {
    label: "Counselling and Therapy",
    href: "/counselling",
    dropdown: [
      {
        label: "Anger Management Counselling",
        href: "/anger-management",
      },
      {
        label: "Relationship Counselling",
        href: "/relationships",
      },
      {
        label: "Depression & Anxiety",
        href: "/depression-anxiety",
      },
      {
        label: "Grief and Loss",
        href: "/grief-loss",
      },
      {
        label: "Career Counselling",
        href: "/career-counselling",
      },
    ],
  },
  {
    label: "Life Coach",
    href: "/life-coach",
    dropdown: [
      {
        label: "Self-Esteem & Confidence",
        href: "/self-esteem-confidence",
      },
      {
        label: "Time Management & Focus",
        href: "/time-management",
      },
      {
        label: "Focus & Productivity",
        href: "/focus-productivity",
      },
      { label: "Changing Habits", href: "/changing-habits" },
      { label: "Public Speaking", href: "/public-speaking" },
    ],
  },
  {
    label: "Allied Health Service",
    href: "/allied-health",
    dropdown: [
      {
        label: "Occupational Therapy",
        href: "/occupational-therapy",
      },
      { label: "Psychology", href: "/psychology" },
    ],
  },
  { label: "Podcasts", href: "/podcast" },
  { label: "Blogs", href: "/wellness-blog" },
  { label: "Course Discovery", href: "/24seven-self-discovery" },
  { label: "Mini Games", href: "/mini-games" },
];

export const navLinks = [
  {
    label: "Home",
    href: "/",
  },
  {
    label: "About",
    href: "/about",
    dropdown: [
      {
        label: "Our Team",
        href: "/teams",
      },
      {
        label: "Contact",
        href: "/contact",
      },
    ],
  },
  {
    label: "Counselling",
    href: "/counselling",
    dropdown: [
      {
        label: "Anger Management",
        href: "/anger-management",
      },
      {
        label: "Relationships",
        href: "/relationships",
      },
      {
        label: "Depression & Anxiety",
        href: "/depression-anxiety",
      },
      {
        label: "Grief & Loss",
        href: "/grief-loss",
      },
      {
        label: "Career Counselling",
        href: "/career-counselling",
      },
    ],
  },
  {
    label: "Life Coach",
    href: "/life-coach",
    dropdown: [
      {
        label: "Self Esteem & Confidence",
        href: "/self-esteem-confidence",
      },
      {
        label: "Time Management",
        href: "/time-management",
      },
      {
        label: "Focus & Productivity",
        href: "/focus-productivity",
      },
      {
        label: "Changing Habits",
        href: "/changing-habits",
      },
      {
        label: "Public Speaking",
        href: "/public-speaking",
      },
    ],
  },
  // {
  //   label: "Courses",
  //   href: "/24seven-self-discovery",
  //   dropdown: [
  //     {
  //       label: "24 Seven Self Discovery",
  //       href: "/24seven-self-discovery",
  //     },
  //   ],
  // },
  {
    label: "Allied Health",
    href: "/allied-health",
    dropdown: [
      {
        label: "Occupational Therapy",
        href: "/occupational-therapy",
      },
      {
        label: "Psychology",
        href: "/psychology",
      },
    ],
  },
  {
    label: "FAQ",
    href: "/counselling-faq",
  },
  {
    label: "Fun Stuff",
    href: "/podcast",
    dropdown: [
      {
        label: "Podcast",
        href: "/podcast",
      },
      // Dynamically need to add the blogs before making this route live
      {
        label: "Wellness Blog",
        href: "/wellness-blog",
      },
      {
        label: "24 Seven Self Discovery",
        href: "/24seven-self-discovery",
      },
      {
        label: "Mini Games",
        href: "/mini-games",
      },
    ],
  },
];

export const v3NavLinks = [
  {
    label: "Home",
    href: "/",
  },
  {
    label: "About",
    href: "/about",
    dropdown: [
      {
        label: "Our Team",
        href: "/teams",
      },
      {
        label: "Contact",
        href: "/contact",
      },
    ],
  },
  {
    label: "Our Team",
    href: "/teams",
  },
  {
    label: "Contact",
    href: "/contact",
  },
  {
    label: "FAQ",
    href: "/counselling-faq",
  },
];
